import { render } from "./CartModal.vue?vue&type=template&id=4a647df4&scoped=true&ts=true"
import script from "./CartModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartModal.vue?vue&type=script&setup=true&lang=ts"

import "./CartModal.vue?vue&type=style&index=0&id=4a647df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a647df4"],['__file',"src/components/modals/CartModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a647df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a647df4', __exports__)) {
    api.reload('4a647df4', __exports__)
  }
  
  module.hot.accept("./CartModal.vue?vue&type=template&id=4a647df4&scoped=true&ts=true", () => {
    api.rerender('4a647df4', render)
  })

}


export default __exports__